import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Analytics } from '@core/services/analytics';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  imports: [RouterOutlet],
})
export class App implements OnInit {
  protected title = 'myrank-client';
  private readonly analytics = inject(Analytics);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    try {
      // await this.analytics.configureUserTracking();
      // Additional debugging and status check
      this.performAnalyticsDebug();
    } catch (error) {
      console.error('❌ App: Failed to configure analytics:', error);
      // Analytics failure shouldn't prevent app from loading
    }

    // Re-run analytics configuration on route changes (SPA navigation)
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(async () => {
        try {
          console.log('🔁 App: Route changed, reconfiguring analytics...');
          await this.analytics.configureUserTracking();
        } catch (err) {
          console.warn('⚠️ App: Reconfigure analytics failed:', err);
        }
      });
  }

  private performAnalyticsDebug(): void {
    // Wait a bit for scripts to fully load
    setTimeout(() => {
      console.log('🔍 App: Performing analytics debug check...');

      const status = this.analytics.getAnalyticsStatus();
      console.log('📊 Analytics Status:', status);

      // Test Clarity connection if available
      if (status.clarity) {
        this.analytics.testClarityConnection();
      } else {
        console.warn('⚠️ App: Clarity not available for testing');
      }

      // Force initialize if user is signed in but Clarity wasn't configured
      if (status.userSignedIn && status.clarity) {
        this.analytics.forceClarityInitialization();
      }
    }, 3000); // Wait 3 seconds for scripts to load
  }
}
